@if(this.isFetching){
    <div class="bloc_loading">
        <ion-spinner></ion-spinner>
    </div>        
}
@else {    
    @if(this.reportQuota){
    
        <div id="content_quota_chart">

            <marv-button class="quota_download" icon="download-outline" [rounded]="true" [isFetching]="this.isFetchingDownload" (click)="this.downloadReport()" />

            <div id="quota_chart">
                @if(this.chartQuotasOptions){
                    <apx-chart
                        [chart]="this.chartQuotasOptions.chart"
                        [series]="this.chartQuotasOptions.series"
                        [plotOptions]="this.chartQuotasOptions.plotOptions"
                        [dataLabels]="this.chartQuotasOptions.dataLabels"
                        [xaxis]="this.chartQuotasOptions.xaxis"
                        [yaxis]="this.chartQuotasOptions.yaxis"
                        [title]="this.chartQuotasOptions.title"
                        [fill]="this.chartQuotasOptions.fill"
                        [legend]="this.chartQuotasOptions.legend"
                    ></apx-chart>
                }
            </div>        
        </div>
    
        <div class="content_quota">
            
            <div class="content_quota_header">
                          
                <!--
                // (Transfert entre OP) 
                @if(this.reportTransferableQuota !== null && this.toOperationsTransferQuotaGlobal.length > 1){
                    <marv-button class="btn_transfer_quota_global" [rounded]="true" icon="arrow-redo-outline" (click)="this.openDrawerTransferQuotaGlobal()"/>
                }
                -->       
                
                <form [formGroup]="this.displayAsDaysForm">
                     <marv-toggle label="{{'DISPLAY_IN_DAYS' | translate}}" formName="displayAsDays"/>
                </form>
                
                @if(!this.reportQuota.globalReportLine){
                    <div class="quota_infos header">
                        <div class="quota_info">
                            <div class="quota_label">{{'QUOTA_GLOBAL' | translate}}</div>
                            <div class="quota_value">{{this.reportQuota.globalQuota | number: '1.0-2'}}</div>
                        </div>
                        <div class="quota_info">
                            <div class="quota_label">{{'QUOTA_CONSUMED' | translate}}</div>
                            <div class="quota_value">{{this.reportQuota.consumedQuota | number: '1.0-2'}}</div>
                        </div>
                    </div>
                }
                @else{
                    <div class="quota_infos header">
                        <div class="quota_info">
                            <div class="quota_label">{{'QUOTA_GLOBAL' | translate}}</div>
                            @if(this.reportQuota.areas && this.reportQuota.areas.length > 1){
                                <div class="quota_value">{{this.getQuotaValue(this.reportQuota.globalReportLine.quotaAllowance) | number: '1.0-2'}}</div>
                            }
                        </div>
                        <div class="quota_info">
                            <div class="quota_label">{{'CONSUMED' | translate}}</div>
                            @if(this.reportQuota.areas && this.reportQuota.areas.length > 1){
                                <div class="quota_value">{{this.getQuotaValue(this.reportQuota.globalReportLine.consumedAndRealisedQuota) | number: '1.0-2'}}</div>
                            }
                        </div>
                        <div class="quota_info">
                            <div class="quota_label">{{'PLANNED_TO_COME' | translate}}</div>
                            @if(this.reportQuota.areas && this.reportQuota.areas.length > 1){
                                <div class="quota_value">{{this.getQuotaValue(this.reportQuota.globalReportLine.quotaAllowance - (this.reportQuota.globalReportLine.consumedAndRealisedQuota+this.reportQuota.globalReportLine.availableQuota)) | number: '1.0-2'}}</div>
                            }
                        </div>
                        <div class="quota_info">
                            <div class="quota_label">{{'BALANCE' | translate}}</div>
                            @if(this.reportQuota.areas && this.reportQuota.areas.length > 1){
                                <div class="quota_value">{{this.getQuotaValue(this.reportQuota.globalReportLine.availableQuota) | number: '1.0-2'}}</div>
                            }
                        </div>
                    </div>
                }
            </div>
            
            <div class="quota_areas">
                @for(area of this.reportQuota.areas; track $index){
                    <div class="quota_area">
                        <div class="quota_area_infos">
                            <div class="quota_area_label">
                                <ion-icon name="map-outline"></ion-icon>{{area.area.name}}
                            </div>
                            <div class="quota_infos">
                                <div class="quota_info">                               
                                    <div class="quota_value">{{this.getQuotaValue(area.globalReportLine.quotaAllowance) | number: '1.0-2'}}</div>
                                </div>
                                <div class="quota_info">                               
                                    <div class="quota_value">{{this.getQuotaValue(area.globalReportLine.consumedAndRealisedQuota) | number: '1.0-2'}}</div>
                                </div>
                                <div class="quota_info">                               
                                    <div class="quota_value">{{this.getQuotaValue(area.globalReportLine.quotaAllowance - (area.globalReportLine.consumedAndRealisedQuota+area.globalReportLine.availableQuota)) | number: '1.0-2'}}</div>
                                </div>
                                <div class="quota_info">                               
                                    <div class="quota_value">{{this.getQuotaValue(area.globalReportLine.availableQuota) | number: '1.0-2'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="quota_sectors">
                            @for(sector of area.sectors; track $index){
                                <div class="quota_sector">
                                    <div class="quota_sector_infos">
                                        <div class="quota_sector_label">
                                            <ion-icon name="trail-sign-outline"></ion-icon>{{sector.customerSector.name}}
                                            <marv-tag size="small">{{sector.customerSector.code}}</marv-tag>
                                        </div>
                                        @if(this.showQuotaAction){
                                            <div class="quota_action">
                                                <marv-button [rounded]="true" icon="arrow-redo-outline" size="small" (click)="this.openDrawerTransferQuota(area, sector)"/>
                                            </div>
                                        }
                                        <div class="quota_infos">
                                            <div class="quota_info">                               
                                                <div class="quota_value">{{this.getQuotaValue(sector.globalReportLine.quotaAllowance) | number: '1.0-2'}}</div>
                                            </div>
                                            <div class="quota_info">                               
                                                <div class="quota_value">{{this.getQuotaValue(sector.globalReportLine.consumedAndRealisedQuota) | number: '1.0-2'}}</div>
                                            </div>
                                            <div class="quota_info">                               
                                                <div class="quota_value">{{this.getQuotaValue(sector.globalReportLine.quotaAllowance - (sector.globalReportLine.consumedAndRealisedQuota+sector.globalReportLine.availableQuota)) | number: '1.0-2'}}</div>
                                            </div>
                                            <div class="quota_info">                               
                                                <div class="quota_value">{{this.getQuotaValue(sector.globalReportLine.availableQuota) | number: '1.0-2'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    @if(sector.operationProfiles && sector.operationProfiles.length > 1){
                                        <div class="quota_profiles">
                                            @for(profile of sector.operationProfiles; track $index){
                                                <div class="quota_profile">
                                                    <div class="quota_profile_infos">
                                                       <div class="quota_profile_label">
                                                           <ion-icon name="person-outline"></ion-icon>{{profile.operationProfile.name}}
                                                       </div>                                                       
                                                       <div class="quota_infos">
                                                           <div class="quota_info">                               
                                                               <div class="quota_value">{{this.getQuotaValue(profile.quotaAllowance) | number: '1.0-2'}}</div>
                                                           </div>
                                                           <div class="quota_info">                               
                                                               <div class="quota_value">{{this.getQuotaValue(profile.consumedAndRealisedQuota) | number: '1.0-2'}}</div>
                                                           </div>
                                                           <div class="quota_info">                               
                                                               <div class="quota_value">{{this.getQuotaValue(profile.quotaAllowance - (profile.consumedAndRealisedQuota+profile.availableQuota)) | number: '1.0-2'}}</div>
                                                           </div>
                                                           <div class="quota_info">                               
                                                               <div class="quota_value">{{this.getQuotaValue(profile.availableQuota) | number: '1.0-2'}}</div>
                                                           </div>
                                                       </div>
                                                   </div>
                                                </div>
                                            }
                                        </div>   
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>                
        </div>
        
        @if(this.reportQuota.unassignedWorkTimePerMission != null && this.reportQuota.unassignedWorkTimePerMission > 0){
            <div class="quota_not_assigned_sector">
                <div>(*) {{'NOT_ASSIGNED_SECTOR' | translate}}</div>
                <div>{{this.getQuotaValue(this.reportQuota.unassignedWorkTimePerMission) | number: '1.0-2'}}</div>
            </div>
        }
    
    }
    @else{
        <marv-message type="info">{{'MSG_NO_QUOTA' | translate}}</marv-message>
    }
}

@if(this.showQuotaAction){  

    @if(this.reportTransferableQuota !== null && this.toOperationsTransferQuotaGlobal.length > 1){
        <marv-drawer #drawerTransferQuotaGlobal (onDidDismiss)="this.onDidDismissDrawerTransferQuotaGlobal($event)">
            
            <div class="drawer_action_quota">
                <div class="title_card">{{'QUOTA_TRANSFER_GLOBAL' | translate}}</div>  
                
                <form class="drawer_action_quota_content" [formGroup]="this.transferQuotaGlobalForm" (ngSubmit)="this.transferQuotaGlobal()">
                    
                    <marv-message type="info">{{'MSG_QUOTA_TRANSFER_GLOBAL' | translate}}</marv-message>   
                    
                    <div class="drawer_action_quota_content_list">                       
                        <marv-select 
                            label="{{'OPERATION_SOURCE' | translate}}" 
                            icon="briefcase-outline" 
                            formName="fromOperationId" 
                            [items]="this.fromOperationsTransferQuotaGlobal" 
                        ></marv-select>

                        <marv-select 
                            label="{{'QUOTA_SOURCE' | translate}}" 
                            icon="pie-chart-outline" 
                            formName="fromQuotaId" 
                            [items]="this.fromQuotasTransferQuotaGlobal" 
                        ></marv-select>

                        <marv-select 
                            label="{{'OPERATION_DESTINATION' | translate}}" 
                            icon="briefcase-outline" 
                            formName="toOperationId" 
                            [items]="this.toOperationsTransferQuotaGlobal" 
                        ></marv-select>

                        <marv-select 
                            label="{{'QUOTA_DESTINATION' | translate}}" 
                            icon="pie-chart-outline" 
                            formName="toQuotaId" 
                            [items]="this.toQuotasTransferQuotaGlobal" 
                        ></marv-select>

                        <marv-input type="number" 
                            icon="time-outline" 
                            formName="quotaQty" 
                            [showBtnClearInput]="true" 
                            [withSpeechToText]="true"  
                            [errorText]="(this.quotaTransferQuotaGlobal ? this.translateService.instant('MSG_ERROR_QUOTA_TRANSFER_VALUE').replace('#available_quota#', this.quotaTransferQuotaGlobal.availableQuota) : this.translateService.instant('MSG_ERROR_QUOTA_TRANSFER_QUOTA_SOURCE'))"                       
                        />

                        <ion-grid class="quota_transfer_summary">
                            <ion-row class="ion-justify-content-center">
                                <ion-col size="auto"><b>{{'MSG_QUOTAS_AFTER_TRANSFER' | translate}}</b></ion-col>
                            </ion-row>
                            <ion-row class="ion-align-items-center ion-justify-content-around">
                                <ion-col>
                                    {{'QUOTA_SOURCE' | translate}}<br>
                                    <b>{{(this.fromSectorTransferQuotaGlobalInfos ? this.fromSectorTransferQuotaGlobalInfos.name : '-')}}</b><br><br>
                                    {{'QUOTA_REMAINING' | translate}}<br>
                                    <marv-tag [color]="((this.fromSectorTransferQuotaGlobalInfos?.newQuota || 0) >= 0 ? 'green' : 'red')" ><b>{{this.fromSectorTransferQuotaGlobalInfos?.newQuota || 0}}</b></marv-tag>
                                </ion-col>
                                <ion-col size="auto" class="quota_transfer_arrow">
                                    <ion-icon name="arrow-forward-outline"></ion-icon>
                                </ion-col>
                                <ion-col>
                                    {{'QUOTA_DESTINATION' | translate}}<br>
                                    <b>{{(this.toSectorTransferQuotaGlobalInfos ? this.toSectorTransferQuotaGlobalInfos.name : '-')}}</b><br><br>
                                    {{'QUOTA_NEW' | translate}}<br>
                                    <marv-tag [color]="((this.toSectorTransferQuotaGlobalInfos?.newQuota || 0) > 0 ? 'green' : 'red')" ><b>{{this.toSectorTransferQuotaGlobalInfos?.newQuota || 0}}</b></marv-tag>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </div>
                    
                    @if(this.transferQuotaGlobalError.length > 0){                        
                        <marv-message type="error">{{this.transferQuotaGlobalError}}</marv-message>                        
                    }
                    
                    @if(this.transferQuotaGlobalWarnings.length > 0){
                        @for(msg of this.transferQuotaGlobalWarnings; track $index){
                            <marv-message type="warning">{{msg}}</marv-message>
                        }
                    }  
                    
                    <ion-grid class="footer_drawer_buttons">
                        <ion-row class="ion-justify-content-around">
                            <ion-col size="auto">
                                <marv-button type="submit" label="{{ 'VALIDATE' | translate }}" [isFetching]="this.isFetchingTransferQuota" icon="checkmark-outline" color="primary" />
                            </ion-col>
                            <ion-col size="auto">
                                <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.closeDrawerTransferQuotaGlobal()" />
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </form>
            </div>
        </marv-drawer>
    }
    
    <marv-drawer #drawerTransferQuota (onDidDismiss)="this.onDidDismissDrawerTransferQuota($event)">
        @if(this.fromAreaTransferQuota){
            <div class="drawer_action_quota">
                <div class="title_card">{{'QUOTA_TRANSFER' | translate}}</div>  
                <form class="drawer_action_quota_content" [formGroup]="this.transferQuotaForm" (ngSubmit)="this.transferQuota()">

                    <marv-message type="info">
                        {{'MSG_INFO_QUOTA_HOUR_TRANSFER_1' | translate}}
                    </marv-message>   
                    <marv-message type="info">
                        {{'MSG_INFO_QUOTA_HOUR_TRANSFER_2' | translate}}
                    </marv-message>

                    <div class="drawer_action_quota_content_list">
                        
                        <marv-select 
                            label="{{'AGENT_PROFIL' | translate}}" 
                            icon="person-outline" 
                            formName="profileId" 
                            [items]="this.profilesTransferQuota" 
                        ></marv-select>
                        
                        <marv-select 
                            label="{{'SECTOR_SOURCE' | translate}}" 
                            icon="trail-sign-outline" 
                            formName="fromSectorId" 
                            [items]="this.fromSectorsTransferQuota" 
                            [withSpeechToText]="true"
                        ></marv-select>
                                                
                        <marv-select 
                            label="{{'AREA_DESTINATION' | translate}}" 
                            icon="map-outline" 
                            formName="toAreaId" 
                            [items]="this.toAreasTransferQuota" 
                            [withSpeechToText]="true"
                            [disabled]="!this.showAreaTransfer"
                            [class.hide_input]="!this.showAreaTransfer"
                        ></marv-select>
                        
                        <marv-select 
                            label="{{'SECTOR_DESTINATION' | translate}}" 
                            icon="trail-sign-outline" 
                            formName="toSectorId" 
                            [items]="this.toSectorsTransferQuota" 
                            [withSpeechToText]="true"
                        ></marv-select>
                        
                        <marv-input type="number" 
                            icon="time-outline" 
                            formName="quotaQty" 
                            [showBtnClearInput]="true" 
                            [withSpeechToText]="true" 
                            [errorText]="(this.profileTransferQuota ? this.translateService.instant('MSG_ERROR_QUOTA_TRANSFER_VALUE').replace('#available_quota#', this.profileTransferQuota.availableQuota) : this.translateService.instant('MSG_ERROR_QUOTA_TRANSFER_SECTOR_SOURCE'))"
                        />
                        
                        <ion-grid class="quota_transfer_summary">
                            <ion-row class="ion-justify-content-center">
                                <ion-col size="auto"><b>{{'MSG_QUOTAS_AFTER_TRANSFER' | translate}}</b></ion-col>
                            </ion-row>
                            <ion-row class="ion-align-items-center ion-justify-content-around">
                                <ion-col>
                                    {{'SECTOR_SOURCE' | translate}}<br>
                                    <b>{{(this.fromSectorTransferQuotaInfos ? this.fromSectorTransferQuotaInfos.name : '-')}}</b><br><br>
                                    {{'QUOTA_REMAINING' | translate}}<br>
                                    <marv-tag [color]="((this.fromSectorTransferQuotaInfos?.newQuota || 0) >= 0 ? 'green' : 'red')" ><b>{{this.fromSectorTransferQuotaInfos?.newQuota || 0}}</b></marv-tag>
                                </ion-col>
                                <ion-col size="auto" class="quota_transfer_arrow">
                                    <ion-icon name="arrow-forward-outline"></ion-icon>
                                </ion-col>
                                <ion-col>
                                    {{'SECTOR_DESTINATION' | translate}}<br>
                                    <b>{{(this.toSectorTransferQuotaInfos ? this.toSectorTransferQuotaInfos.name : '-')}}</b><br><br>
                                    {{'QUOTA_NEW' | translate}}<br>
                                    <marv-tag [color]="((this.toSectorTransferQuotaInfos?.newQuota || 0) > 0 ? 'green' : 'red')" ><b>{{this.toSectorTransferQuotaInfos?.newQuota || 0}}</b></marv-tag>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                            
                    </div>
                    
                    @if(this.transferQuotaError.length > 0){                        
                        <marv-message type="error">{{this.transferQuotaError}}</marv-message>                        
                    }

                    @if(this.transferQuotaWarnings.length > 0){
                        @for(msg of this.transferQuotaWarnings; track $index){
                            <marv-message type="warning">{{msg}}</marv-message>
                        }
                    }                    

                    <ion-grid class="footer_drawer_buttons">
                        <ion-row class="ion-justify-content-around">
                            <ion-col size="auto">
                                <marv-button type="submit" label="{{ 'VALIDATE' | translate }}" [isFetching]="this.isFetchingTransferQuota" icon="checkmark-outline" color="primary" />
                            </ion-col>
                            <ion-col size="auto">
                                <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.closeDrawerTransferQuota()" />
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </form>
            </div>
        }
    </marv-drawer>

}